<template>
  <div>
    <ed-form :model="formData">
      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Empresa"
        v-model="formData.id_emp"
        :items="lstEmpresa"
        :loading="loadingEmpresa"
        @input="getFuncionario"
        @search="getEmpresa"
        clearable
        remote
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
        label="Layout"
        v-model="formData.layout"
        :items="lstLayout"
        itemValue="codigo"
        clearable
      />

      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
        label="Periodo de Apuramento"
        v-model="formData.periodo"
        format="MM/yyyy"
        type="month"
      />

      <div
        class="
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12
          text-center
          mt-5
        "
      >
        <ed-button
          type="success"
          label="Consultar Informações no eSocial"
          icon="fa fa-search"
          :disabled="
            !formData.id_emp || !formData.layout || !formData.periodo
              ? true
              : false
          "
          @click="consultar"
        />
      </div>
    </ed-form>

    <div class="col-12 mt-5" v-if="formData.strXml">
      <h4><b>Informações no eSocial</b></h4>

      <XmlViewer :xml="formData.strXml" />
    </div>
  </div>
</template>

<script>
import XmlViewer from "vue-xml-viewer";
import {
  EdForm,
  EdButton,
  EdInputSelect,
  EdInputText,
  EdInputDate,
} from "template";

export default {
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: {
    XmlViewer,
    EdForm,
    EdButton,
    EdInputSelect,
    EdInputText,
    EdInputDate,
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: [],
    },
    loadingEmpresa: {
      type: Boolean,
      default: false,
    },
    loadingFuncionario: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["getEmpresa", "getFuncionario", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function (newVal) {},
      deep: true,
    },
    loadingEmpresa() {},
    loadingFuncionario() {},
  },

  data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null,
      },
      lstLayout: [
        {
          codigo: "S-1000",
          nome: "S-1000",
        },
        {
          codigo: "S-1005",
          nome: "S-1005",
        },
        {
          codigo: "S-1010",
          nome: "S-1010",
        },
        {
          codigo: "S-1020",
          nome: "S-1020",
        },
        {
          codigo: "S-1030",
          nome: "S-1030",
        },
        {
          codigo: "S-1035",
          nome: "S-1035",
        },
        {
          codigo: "S-1040",
          nome: "S-1040",
        },
        {
          codigo: "S-1050",
          nome: "S-1050",
        },
        {
          codigo: "S-1060",
          nome: "S-1060",
        },
        {
          codigo: "S-1065",
          nome: "S-1065",
        },
        {
          codigo: "S-1070",
          nome: "S-1070",
        },
        {
          codigo: "S-1080",
          nome: "S-1080",
        },
        {
          codigo: "S-1200",
          nome: "S-1200",
        },
        {
          codigo: "S-1202",
          nome: "S-1202",
        },
        {
          codigo: "S-1207",
          nome: "S-1207",
        },
        {
          codigo: "S-1210",
          nome: "S-1210",
        },
        {
          codigo: "S-1250",
          nome: "S-1250",
        },
        {
          codigo: "S-1260",
          nome: "S-1260",
        },
        {
          codigo: "S-1270",
          nome: "S-1270",
        },
        {
          codigo: "S-1280",
          nome: "S-1280",
        },
        {
          codigo: "S-1295",
          nome: "S-1295",
        },
        {
          codigo: "S-1298",
          nome: "S-1298",
        },
        {
          codigo: "S-1299",
          nome: "S-1299",
        },
        {
          codigo: "S-1300",
          nome: "S-1300",
        },
        {
          codigo: "S-2190",
          nome: "S-2190",
        },
        {
          codigo: "S-2200",
          nome: "S-2200",
        },
        {
          codigo: "S-2205",
          nome: "S-2205",
        },
        {
          codigo: "S-2206",
          nome: "S-2206",
        },
        {
          codigo: "S-2210",
          nome: "S-2210",
        },
        {
          codigo: "S-2220",
          nome: "S-2220",
        },
        {
          codigo: "S-2230",
          nome: "S-2230",
        },
        {
          codigo: "S-2240",
          nome: "S-2240",
        },
        {
          codigo: "S-2241",
          nome: "S-2241",
        },
        {
          codigo: "S-2245",
          nome: "S-2245",
        },
        {
          codigo: "S-2250",
          nome: "S-2250",
        },
        {
          codigo: "S-2298",
          nome: "S-2298",
        },
        {
          codigo: "S-2299",
          nome: "S-2299",
        },
        {
          codigo: "S-2300",
          nome: "S-2300",
        },
        {
          codigo: "S-2306",
          nome: "S-2306",
        },
        {
          codigo: "S-2399",
          nome: "S-2399",
        },
        {
          codigo: "S-2400",
          nome: "S-2400",
        },
        {
          codigo: "S-3000",
          nome: "S-3000",
        },
        {
          codigo: "S-5001",
          nome: "S-5001",
        },
        {
          codigo: "S-5002",
          nome: "S-5002",
        },
        {
          codigo: "S-5011",
          nome: "S-5011",
        },
        {
          codigo: "S-5012",
          nome: "S-5012",
        },
      ],
    };
  },

  created() {},

  mounted() {},

  methods: {
    consultar() {
      this.$root.$loading.set(true);
      this.formData.strXml = null;

      this.$root.$request
        .post(
          "esocial/lotes/consultar/" +
            this.formData.id_emp +
            "/evento-empresa",
          this.formData
        )
        .then((result) => {
          this.$root.$loading.set(false);

          console.log("result", result);
          if (result.status == 200) {
            this.formData.strXml = result.data;
          } else if (result.status != 400) {
            // this.$alert(result.msg, "Atenção", {
            //   confirmButtonText: "OK",
            // });
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// consulta-evento-empresa.vue?324ba712